<template>
	<div>
		<InputField
			:label="$props.text"
			@change.native="callChange"
			class="pa-0 ma-0 ml-1 mr-1 mt-2"
			v-if="$props.type=='string' && $props.filterType!='inner'"
			v-model="dataValues[$props.name]"
		></InputField>
		<InputField
			@change.native="callChange"
			class="pa-0 ma-0 ml-1 mr-1 mt-2"
			simple
			v-if="$props.type=='string' && $props.filterType=='inner'"
			v-model="dataValues[$props.name]"
		></InputField>

		<v-layout>
			<CheckBox
				:label="''"
				@click.native="callChange"
				class="filter-enable-checkbox"
				v-if="$props.type=='price_range'"
				v-model="dataValues[$props.name+'_from_term']"></CheckBox>
			<CurrencyField
				:label="$props.text+' '+$t('labels.from')"
				@change.native="callChange"
				v-if="$props.type=='price_range'"
				v-model="dataValues[$props.name+'_from']"></CurrencyField>
		</v-layout>
		<v-layout>
			<CheckBox
				:label="''"
				@click.native="callChange"
				class="filter-enable-checkbox"
				v-if="$props.type=='price_range'"
				v-model="dataValues[$props.name+'_to_term']"></CheckBox>
			<CurrencyField
				:label="$props.text+' '+$t('labels.to')"
				@change.native="callChange"
				v-if="$props.type=='price_range'"
				v-model="dataValues[$props.name+'_to']"></CurrencyField>
		</v-layout>

		<v-layout>
			<CheckBox
				:label="''"
				@click.native="callChange"
				class="filter-enable-checkbox"
				v-if="$props.type=='number_range'"
				v-model="dataValues[$props.name+'_from_term']"></CheckBox>
			<InputField
				:label="$props.text+' '+$t('labels.from')"
				:mask="'#######'"
				@change.native="callChange"
				v-if="$props.type=='number_range'"
				v-model="dataValues[$props.name+'_from']"
			></InputField>
		</v-layout>
		<v-layout>
			<CheckBox
				:label="''"
				@click.native="callChange"
				class="filter-enable-checkbox"
				v-if="$props.type=='number_range'"
				v-model="dataValues[$props.name+'_to_term']"></CheckBox>
			<InputField
				:label="$props.text+' '+$t('labels.to')"
				:mask="'#######'"
				@change.native="callChange"
				v-if="$props.type=='number_range'"
				v-model="dataValues[$props.name+'_to']"
			></InputField>
		</v-layout>

		<Dropdown
			:ajax="true"
			:clearable="true"
			:data="dropdownUrl"
			:label="$props.text"
			@changes="callChange"
			v-if="$props.type.includes('dropdown') && $props.filterType!='inner'"
			v-model="dataValues[$props.name]"></Dropdown>
		<Dropdown
			:ajax="true"
			:clearable="true"
			:data="dropdownUrl"
			:label="$props.text"
			@changes="callChange"
			simple
			v-if="$props.type.includes('dropdown') && $props.filterType==='inner'"
			v-model="dataValues[$props.name]"></Dropdown>

		<Dropdown
			:ajax="false"
			:clearable="true"
			:data="dropdownData"
			:label="$props.text"
			@changes="callChange"
			v-if="$props.type.includes('harddown') && $props.filterType!='inner'"
			v-model="dataValues[$props.name]"></Dropdown>
		<Dropdown
			:ajax="false"
			:clearable="true"
			:data="dropdownData"
			:label="$props.text"
			@changes="callChange"
			simple
			v-if="$props.type.includes('harddown') && $props.filterType==='inner'"
			v-model="dataValues[$props.name]"></Dropdown>

		<DropdownMultiple
			:ajax="true"
			:data="dropdownUrl"
			:label="$props.text"
			@changes="callChange" v-if="$props.type.includes('multiple')"
			v-model="dataValues[$props.name]"></DropdownMultiple>

		<Tags
			:ajax="true"
			:data="dropdownUrl"
			:label="$props.text"
			@changes="callChange" v-if="$props.type.includes('tags')"
			v-model="dataValues[$props.name]"></Tags>

		<DatePicker :clearable="true" :dateLabel="$props.text+' '+$t('labels.from')"
					@changes="callChange"
					class="pa-0 ma-0 ml-1 mr-1 mt-2"
					v-if="$props.type=='date_range'" v-model="dataValues[$props.name+'_from']"/>
		<DatePicker :clearable="true" :dateLabel="$props.text+' '+$t('labels.to')"
					@changes="callChange"
					class="pa-0 ma-0 ml-1 mr-1 mt-2"
					v-if="$props.type=='date_range'" v-model="dataValues[$props.name+'_to']"/>

		<v-radio-group
			@click.native="callChange" v-if="$props.type=='boolean' || $props.type=='boolean_yes'"
			v-model="dataValues[$props.name]">
			<template slot="label">
				{{ $props.text }}:
			</template>
			<v-radio :label="$t('buttons.yes')" :value="true"></v-radio>
			<v-radio :label="$t('buttons.no')" :value="false"></v-radio>
			<v-radio :label="$t('buttons.all')" :value="null"></v-radio>
		</v-radio-group>
		<v-radio-group
			@click.native="callChange" v-if="$props.type=='boolean_partial'"
			v-model="dataValues[$props.name]">
			<template slot="label">
				{{ $props.text }}:
			</template>
			<v-radio :label="$t('buttons.yes')" :value="1"></v-radio>
			<v-radio :label="$t('buttons.no')" :value="0"></v-radio>
			<v-radio :label="$t('buttons.all')" :value="null"></v-radio>
			<v-radio :label="$t('buttons.partial')" :value="2"></v-radio>
		</v-radio-group>
	</div>
</template>

<script>
import CurrencyField from "./CurrencyField";
import DatePicker from "./DatePicker";
import InputField from "./InputField";
import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import DropdownMultiple from "./DropdownMultiple";
import Tags from "./Tags";

export default {
	name: "FilterField",
	components: {DatePicker, InputField, CurrencyField, CheckBox, Dropdown, Tags, DropdownMultiple},
	props: ['value', 'text', 'type', 'name', 'filterType'],
	data() {
		return {
			dataValues: this.$props.value
		}
	},
	computed: {
		dropdownUrl() {
			if (!this.$props.type.includes('|')) {
				return null;
			}
			return this.$props.type.split('|')[1];
		},
		dropdownData() {
			if (!this.$props.type.includes('|')) {
				return null;
			}
			let key = this.$props.type.split('|')[1];
			return this.$filterData[key];
		}
	},
	watch: {
		dataValues: {
			handler: function () {
				this.$emit('input', this.dataValues);
			},
			deep: true
		},
		value() {
			this.dataValues = this.$props.value;
		}
	},
	methods: {
		callChange() {
			this.$emit('changes');
		}
	}
}
</script>

<style scoped>
.filter-enable-checkbox {
	max-width: 30px;
}
</style>
